import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';

import { Address_Interface, Empty_Address_Interface } from 'src/app/Interface/Address_Interface';
import { Customer_Interface, Empty_Customer_Interface } from 'src/app/Interface/Customer_Interface';
import { Customer_List_Interface, Empty_Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { DeviceBehfa_Interface, Empty_DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { Devicepersian_Interface, Empty_Devicepersian_Interface } from 'src/app/Interface/Devicepersian_Interface';
import { Device_Interface, Empty_Device_Interface } from 'src/app/Interface/Device_Interface';
import { Empty_ExpertCalibration_Interface, ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { KarshnasMasol_Interface } from 'src/app/Interface/KarshnasMasol_Interface';
import { Empty_LetterRequestCustomer_Device_Interface, LetterRequestCustomer_Device_Interface } from 'src/app/Interface/LetterRequestCustomer_Device_Interface';
import { LetterRequestCustomer_History_Interface } from 'src/app/Interface/LetterRequestCustomer_History_Interface';
import { Empty_LetterRequestCustomer_List_Interface, LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { Empty_LetterRequestCustomer_Order_Interface, LetterRequestCustomer_Order_Interface } from 'src/app/Interface/LetterRequestCustomer_Order_Interface';
import { Empty_LetterRequestCustomer_Schedule_Interface, LetterRequestCustomer_Schedule_Interface } from 'src/app/Interface/LetterRequestCustomer_Schedule_Interface';
import { Empty_Letter_Interface, Letter_Interface } from 'src/app/Interface/Letter_Interface';
import { MailMessage_Interface } from 'src/app/Interface/MailMessage_Interface';
import { Empty_Tariff_Interface, Tariff_Interface } from 'src/app/Interface/Tariff_Interface';
import { Textletter_Interface } from 'src/app/Interface/Textletter_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { DeviceService } from 'src/app/Service/Device/Device.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { DevicepersianService } from 'src/app/Service/Devicepersian/Devicepersian.service';
import { ExpertCalibrationService } from 'src/app/Service/ExpertCalibration/ExpertCalibration.service';
import { ExpirationService } from 'src/app/Service/Expiration/Expiration.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { MailMessageService } from 'src/app/Service/MailMessage/MailMessage.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PriceService } from 'src/app/Service/Price/Price.service';
import { SubjectLetterService } from 'src/app/Service/SubjectLetter/SubjectLetter.service';
import { TariffService } from 'src/app/Service/Tariff/Tariff.service';
import { TextletterService } from 'src/app/Service/Textletter/Textletter.service';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-LetterRequestCustomerForm',
  templateUrl: './LetterRequestCustomerForm.component.html',
  styleUrls: ['./LetterRequestCustomerForm.component.scss']
})
export class LetterRequestCustomerFormComponent implements OnInit {
  Letter_Form_Id: any
  Letter_Draft_Form_Id: any

  Record_Letter: Letter_Interface = Empty_Letter_Interface()


  BaseUrl = environment.BaseUrl + "Letterrequestcustomerprint/Show?id="
  BaseUrl1 = environment.BaseUrl + "Letterrequestcustomerprint/Schedule1?id="
  BaseUrl2 = environment.BaseUrl + "Letterrequestcustomerprint/DeviceBehfa?id="
  BaseUrl3 = environment.BaseUrl + "Letterrequestcustomerprint/Mission?id="
  letterRequestCustomer2: number = 0

  canEditMainForm: boolean
  canDeleteHistoryRecord: boolean
  canEditPlannigForm: boolean
  canCheckingPlaningForm: boolean
  canDownloadPDF: boolean
  canDownloadPDFPlaning: boolean
  hiddenDetailAndPrice: boolean = true
  canShowSendSMS: boolean
  canFillReviewForm: boolean = false
  has_calibration_customer_order: boolean = false

  parentRefer: number = 0
  HourList: Array<number> = []

  constructor(
    private Customer_Service: CustomerService,
    private modalService: BsModalService,
    private MailMessage_Service: MailMessageService,
    private Nav_Service: NavService,
    private Tariff_Service: TariffService,
    private Device_Service: DeviceService,
    private Textletter_Service: TextletterService,
    private Devicepersian_Service: DevicepersianService,
    private ExpertCalibration_Service: ExpertCalibrationService,
    private SubjectLetter_Service: SubjectLetterService,
    private route: ActivatedRoute,
    private Expiration_Service: ExpirationService,
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private Price_Service: PriceService,
    private Alertify_Service: AlertifyService
  ) { }

  ngOnInit() {
    localStorage.removeItem('Daro_User_Comment')
    this.Letter_Form_Id = this.route.snapshot.paramMap.get('id')
    this.Letter_Draft_Form_Id = Number(this.route.snapshot.paramMap.get('draft'))
    this.HourList = Array(24).fill(1).map((x, i) => i);

    this.AddNewLetter = new FormGroup({
      id: new FormControl(),
      giver_name: new FormControl(null, Validators.required),
      giver_semat: new FormControl(null, Validators.required),
      subject_id: new FormControl("0"),
      peyvast: new FormControl("1"),
      takhfif: new FormControl("0", Validators.required),
      sex: new FormControl("1", Validators.required),
      arsh_afzoodeh: new FormControl("0", Validators.required),
      bazgashtBeNamehShomareh: new FormControl(null, Validators.required),
      bazgashtBeNamehTarikh: new FormControl(null, Validators.required),
      pishPardakht: new FormControl("0"),
      pishPardakhtAlpah: new FormControl(""),
      textletter_id: new FormControl("0"),

      khadamat: new FormControl("0"),
      khadamatAlpah: new FormControl(""),
    })

    this.DeviceForm = new FormGroup({
      id: new FormControl(),
      device_id: new FormControl("0", Validators.required),
      location: new FormControl("0", Validators.required),
      tedad: new FormControl(null, Validators.required),
      dsc: new FormControl(null),
      dscUser: new FormControl(null),
      Expiration: new FormControl("0", Validators.required),
      incRailModir: new FormControl("0", Validators.required),
    })

    this.ScheduleForm = new FormGroup({
      id: new FormControl(),
      persianDate: new FormControl(null, Validators.required),
      dsc: new FormControl(null),
      startHour: new FormControl("9", Validators.required),
      endHour: new FormControl("15", Validators.required),
      comment: new FormControl("0", Validators.required),
    })

    this.MailMessageForm = new FormGroup({
      mailmessage_id: new FormControl("0", Validators.required),
    })

    this.MailMessageForm_Schedule = new FormGroup({
      mailmessage_id: new FormControl("0", Validators.required),
    })

    this.BaseUrl = environment.BaseUrl + "Letterrequestcustomerprint/Show?id="
    this.BaseUrl1 = environment.BaseUrl + "Letterrequestcustomerprint/Schedule1?id="
    this.BaseUrl2 = environment.BaseUrl + "Letterrequestcustomerprint/DeviceBehfa?id="
    this.BaseUrl3 = environment.BaseUrl + "Letterrequestcustomerprint/Mission?id="

    if (this.Letter_Form_Id && this.Letter_Form_Id != '0') {
      this.Letter_Draft_Form_Id = "0"
      this.OnInitail_Form();
    }
    else if (this.Letter_Draft_Form_Id && this.Letter_Draft_Form_Id != 0) {
      this.LetterRequestCustomer_Service.GetLetterRequestCustomerPeyvaset(this.Letter_Draft_Form_Id,0,"").subscribe(
        data => {
          this.Selected_DataList_LetterRequestCustomer_Record = data[0]
          this.Selected_DataList_LetterRequestCustomer = data[0]
          this.get_Form_peyvast().setValue("1")
          this.get_Form_bazgashtBeNamehShomareh().setValue(data[0].code)


          this.Data_Seleted_Customer.id = Number(this.Selected_DataList_LetterRequestCustomer.customerId)
          this.Data_Seleted_Customer.name = this.Selected_DataList_LetterRequestCustomer.customer + ''
          this.Data_Seleted_Customer.code = this.Selected_DataList_LetterRequestCustomer.code + ''

          this.OnInitail_Form_DraftCopy()


        }, error => {


        }
      )
    }
    else {
      this.Letter_Draft_Form_Id = "0"
      this.Letter_Form_Id = "0"
      this.ReadData_SubjectLetter()
    }

  }

  OnInitail_Form() {
    this.LetterRequestCustomer_Service.GetSingle(this.Letter_Form_Id).subscribe(
      data => {

        this.Data_Seleted_Customer = data['cusomter']
        this.Data_Seleted_Address = data['address']
        this.Schedule_DataList = data['schedules']
        this.FormAdded_MailMessage = data['mail']
        this.FormAdded_MailMessage_Schedule = data['mail_Schedules']
        this.has_calibration_customer_order = data['has_calibration_customer_order']

        this.FormAdded_Dsc = []
        for (let item of data['dsc']) {
          this.FormAdded_Dsc.push(item['dsc'])
          this.FormAdded_Dsc_Modir.push(item['modirEdit'])
        }

        this.Letter_Form_Code = data['lettercode']
        this.Letter_Form_Code_Code = data['code']
        this.Selected_DataList_LetterRequestCustomer_Record = data['parent']

        this.DeviceFormList = data['device']

        for(let item of this.DeviceFormList)
        {
          this.Calc_IncreaseModir(true,item)
        }

        this.Record_Letter = data['main']

        localStorage.setItem('Daro_User_Comment', JSON.stringify(this.Data_Seleted_Customer));

        this.Data_Seleted_ReciveCustomer.id = Number(this.Record_Letter.reciver_Customer_id)
        this.Data_Seleted_ReciveCustomer.name = data['reciver_Customer']
        this.Data_Seleted_ReciveCustomer_Dsc = this.Record_Letter.reciver_Customer_Dsc + ''


        if (this.Selected_DataList_LetterRequestCustomer_Record.id > 0) {
          this.get_Form_peyvast().setValue("1")

        }

        this.get_Form_bazgashtBeNamehTarikh().setValue(data['bazgashtBeNamehTarikh'])

        if (data['main']['peyvast'] == true)
          this.get_Form_peyvast().setValue('1')
        else
          this.get_Form_peyvast().setValue('0')

        if (data['main']['sex'] == true)
          this.get_Form_sex().setValue('1')
        else
          this.get_Form_sex().setValue('0')

        this.get_Form_giver_name().setValue(this.Record_Letter.giver_name)
        this.get_Form_giver_semat().setValue(this.Record_Letter.giver_semat)
        this.get_Form_subject_id().setValue(this.Record_Letter.subject_id)

        this.get_Form_bazgashtBeNamehShomareh().setValue(this.Record_Letter.bazgashtBeNamehShomareh)
        this.get_Form_takhfif().setValue(this.Record_Letter.takhfif)


        this.get_Form_arsh_afzoodeh().setValue(this.Record_Letter.arsh_afzoodeh)
        this.get_Form_pishPardakht().setValue(this.Record_Letter.pishPardakht)
        this.get_Form_khadamat().setValue(this.Record_Letter.khadamat)
        this.ReadData_Textletter()
        this.ReadData_SubjectLetter()
        this.Calc_DeviceFormListPriceTotal()
        this.get_Form_textletter_id().setValue(this.Record_Letter.textletter_id)
        this.pishPardakht_Change()
        this.khadamat_Change()


      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  OnInitail_Form_DraftCopy() {
    this.LetterRequestCustomer_Service.GetSingle(this.Letter_Draft_Form_Id).subscribe(
      data => {
        this.Data_Seleted_Customer = data['cusomter']
        this.Data_Seleted_Address = data['address']
        this.FormAdded_MailMessage = data['mail']
        this.Letter_Form_Code = data['lettercode']

        for (let item of data['dsc']) {
          this.FormAdded_Dsc.push(item['dsc'])
          this.FormAdded_Dsc_Modir.push(item['modirEdit'])
        }

        this.DeviceFormList = data['device']
        var temp: Letter_Interface = data['main']



        if (this.Selected_DataList_LetterRequestCustomer_Record.id > 0) {
          this.get_Form_peyvast().setValue("1")

        }

        this.get_Form_bazgashtBeNamehTarikh().setValue(data['bazgashtBeNamehTarikh'])


        if (data['main']['peyvast'] == true)
          this.get_Form_peyvast().setValue('1')
        else
          this.get_Form_peyvast().setValue('0')

        if (data['main']['sex'] == true)
          this.get_Form_sex().setValue('1')
        else
          this.get_Form_sex().setValue('0')

        this.get_Form_giver_name().setValue(temp.giver_name)
        this.get_Form_giver_semat().setValue(temp.giver_semat)
        this.get_Form_subject_id().setValue(temp.subject_id)

        this.get_Form_bazgashtBeNamehShomareh().setValue(temp.bazgashtBeNamehShomareh)
        this.get_Form_takhfif().setValue(temp.takhfif)


        this.get_Form_arsh_afzoodeh().setValue(temp.arsh_afzoodeh)
        this.get_Form_pishPardakht().setValue(temp.pishPardakht)
        this.get_Form_khadamat().setValue(temp.khadamat)
        this.ReadData_Textletter()
        this.ReadData_SubjectLetter()

        this.Calc_DeviceFormListPriceTotal()
        this.get_Form_textletter_id().setValue(temp.textletter_id)
        this.pishPardakht_Change()
        this.khadamat_Change()


      }
    )
  }




  //#region  Form Add

  AddNewLetter: FormGroup;

  get_Form_giver_name() {
    return this.AddNewLetter.get('giver_name') as FormControl;
  }
  get_Form_giver_semat() {
    return this.AddNewLetter.get('giver_semat') as FormControl;
  }
  get_Form_subject_id() {
    return this.AddNewLetter.get('subject_id') as FormControl;
  }
  get_Form_peyvast() {
    return this.AddNewLetter.get('peyvast') as FormControl;
  }
  get_Form_takhfif() {
    return this.AddNewLetter.get('takhfif') as FormControl;
  }
  get_Form_sex() {
    return this.AddNewLetter.get('sex') as FormControl;
  }
  get_Form_arsh_afzoodeh() {
    return this.AddNewLetter.get('arsh_afzoodeh') as FormControl;
  }
  get_Form_bazgashtBeNamehShomareh() {
    return this.AddNewLetter.get('bazgashtBeNamehShomareh') as FormControl;
  }
  get_Form_bazgashtBeNamehTarikh() {
    return this.AddNewLetter.get('bazgashtBeNamehTarikh') as FormControl;
  }
  get_Form_pishPardakht() {
    return this.AddNewLetter.get('pishPardakht') as FormControl;
  }

  get_Form_pishPardakhtAlpah() {
    return this.AddNewLetter.get('pishPardakhtAlpah') as FormControl;
  }

  get_Form_textletter_id() {
    return this.AddNewLetter.get('textletter_id') as FormControl;
  }

  get_Form_khadamat() {
    return this.AddNewLetter.get('khadamat') as FormControl;
  }

  get_Form_khadamatAlpah() {
    return this.AddNewLetter.get('khadamatAlpah') as FormControl;
  }

  pishPardakht_Change() {
    this.Price_Service.GetPriceAlphabet(this.get_Form_pishPardakht().value).subscribe(
      data => {
        this.get_Form_pishPardakhtAlpah().setValue(data['price'])
      }
    )
  }

  khadamat_Change() {
    this.Calc_DeviceFormListPriceTotal()
    this.Price_Service.GetPriceAlphabet(this.get_Form_khadamat().value).subscribe(
      data => {
        this.get_Form_khadamatAlpah().setValue(data['price'])
      }
    )
  }

  //#endregion

  //#region  مشتری
  ProcssingCustomer: boolean = false
  modalRef_Customer: any;
  modalRef_CustomerAdress: any;
  page: number = 0

  Edit_Customer_Record: Customer_Interface = Empty_Customer_Interface()

  Search_CodeName_Customer_Table: string = ''
  Data_Seleted_ReciveCustomer_Dsc: string = ''
  Search_Type_Customer_Table: string = '2'

  DataList_Customer: Array<Customer_List_Interface> = []
  DataList_Address: Array<Address_Interface> = []
  Data_Seleted_Customer: Customer_List_Interface = Empty_Customer_List_Interface()
  Data_Seleted_ReciveCustomer: Customer_List_Interface = Empty_Customer_List_Interface()
  Data_Seleted_Address: Address_Interface = Empty_Address_Interface()

  ReadData_Customer_KeySearch_Timer: any
  ReadData_Customer_KeySearch() {

    if (this.ReadData_Customer_KeySearch_Timer) {
      clearTimeout(this.ReadData_Customer_KeySearch_Timer);
      this.ReadData_Customer_KeySearch_Timer = null;
    }

    this.ReadData_Customer_KeySearch_Timer = setTimeout(function () {
      this.ReadData_Customer()
    }.bind(this), 1000);

  }

  ReadData_Customer() {

    if (!this.Search_CodeName_Customer_Table) {
      this.DataList_Customer = []
    }
    else {


      this.ProcssingCustomer = true
      this.Customer_Service.GetSearchCalibration(this.Search_CodeName_Customer_Table).subscribe(
        data => {
          this.DataList_Customer = data
          this.ProcssingCustomer = false
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }

  Data_Seleted_Customer_Type: number = 0
  openModal_Customer(template: TemplateRef<any>, type_Customer) {
    this.Data_Seleted_Customer_Type = type_Customer
    this.modalRef_Customer = this.modalService.show(template);
  }

  openModal_CustomerAddress(template: TemplateRef<any>) {
    this.modalRef_CustomerAdress = this.modalService.show(template);
  }

  Set_Selected_Customer_Record(item) {

    this.get_Form_takhfif().setValue(item.takhfif)

    if (this.Data_Seleted_Customer_Type == 0) {
      this.Selected_DataList_LetterRequestCustomer = Empty_LetterRequestCustomer_List_Interface()
      this.Data_Seleted_Customer = item
      //this.ReadData_Initial_Customer()
    }
    else {
      this.Data_Seleted_ReciveCustomer = item
    }



    this.modalRef_Customer.hide()

  }

  Remove_ReciveCustomer() {
    this.Data_Seleted_ReciveCustomer = Empty_Customer_List_Interface()
  }


  ReadData_Initial_Customer() {

    if (this.Data_Seleted_Customer.id > 0) {
      this.Customer_Service.GetSingle(this.Data_Seleted_Customer.id).subscribe(
        data => {
          this.DataList_Address = data['address']
        }
      )
    }
  }

  Set_Data_Seleted_Address(item) {
    this.Data_Seleted_Address = item
    this.Data_Seleted_Address.address = this.Data_Seleted_Address.title + ' ' + this.Data_Seleted_Address.address
    this.modalRef_CustomerAdress.hide()
  }


  //#endregion

  //#region SubjectLetter

  DataList_SubjectLetter: Array<General_Interface> = []
  ReadData_SubjectLetter() {
    this.SubjectLetter_Service.GetActiveList().subscribe(
      data => {
        this.DataList_SubjectLetter = data
        this.ReadData_MailMessage()
      }, error => {


      }
    )
  }



  //#endregion

  //#region MailMessage
  MailMessageForm: FormGroup
  DataList_MailMessage: Array<MailMessage_Interface> = []
  FormAdded_MailMessage: Array<General_Interface> = []

  ReadData_MailMessage() {
    this.MailMessage_Service.GetRecord(1).subscribe(
      data => {
        this.ReadData_MailMessage_Shcedule()
        this.DataList_MailMessage = data
      }
    )
  }
  get_MailMessageForm_mailmessage_id() {
    return this.MailMessageForm.get('mailmessage_id') as FormControl;
  }

  MailMessageForm_Delete(id) {
    this.FormAdded_MailMessage.splice(id, 1)
    this.Alertify_Service.SuccessMessage(" حذف شد")
  }

  MailMessageForm_Submit() {
    if (this.get_MailMessageForm_mailmessage_id().value == "0") {
      this.Alertify_Service.ErrorMessage("پیام نامه انتخاب نمائید")
    }
    else {
      var Chekcer: boolean = false
      for (let detail of this.FormAdded_MailMessage) {
        if (detail.id == Number(this.get_MailMessageForm_mailmessage_id().value)) {
          Chekcer = true
          break
        }
      }

      if (Chekcer) {
        this.Alertify_Service.ErrorMessage("پیام نامه مورد نظر در لیست ثبت شده است")
      }
      else {
        var temp: General_Interface = Empty_General_Interface()
        temp.id = Number(this.get_MailMessageForm_mailmessage_id().value)
        temp.title = this.Find_MailMessage(temp.id)
        this.FormAdded_MailMessage.push(temp)
        this.Alertify_Service.SuccessMessage('اطلاعات ثبت شد')
      }
    }

  }

  Find_MailMessage(id: number) {
    for (let item of this.DataList_MailMessage) {
      if (id == item.id) {
        return item.title
      }
    }
  }

  //#endregion

  //#region MailMessage
  MailMessageForm_Schedule: FormGroup
  DataList_MailMessage_Schedule: Array<MailMessage_Interface> = []
  FormAdded_MailMessage_Schedule: Array<General_Interface> = []

  ReadData_MailMessage_Shcedule() {
    this.MailMessage_Service.GetRecord(4).subscribe(
      data => {
        this.Read_Order_Operation()
        this.DataList_MailMessage_Schedule = data
      }
    )
  }

  get_MailMessageForm_Schedule_mailmessage_id() {
    return this.MailMessageForm_Schedule.get('mailmessage_id') as FormControl;
  }

  MailMessageForm_Schedule_Delete(id) {
    this.FormAdded_MailMessage_Schedule.splice(id, 1)
    this.Alertify_Service.SuccessMessage(" حذف شد")
  }

  MailMessageForm_Schedule_Submit() {
    if (this.get_MailMessageForm_Schedule_mailmessage_id().value == "0") {
      this.Alertify_Service.ErrorMessage("پیام نامه انتخاب نمائید")
    }
    else {
      var Chekcer: boolean = false
      for (let detail of this.FormAdded_MailMessage_Schedule) {
        if (detail.id == Number(this.get_MailMessageForm_Schedule_mailmessage_id().value)) {
          Chekcer = true
          break
        }
      }

      if (Chekcer) {
        this.Alertify_Service.ErrorMessage("پیام نامه مورد نظر در لیست ثبت شده است")
      }
      else {
        var temp: General_Interface = Empty_General_Interface()
        temp.id = Number(this.get_MailMessageForm_Schedule_mailmessage_id().value)
        temp.title = this.Find_MailMessage_Schedule(temp.id)
        this.FormAdded_MailMessage_Schedule.push(temp)
        this.Alertify_Service.SuccessMessage('اطلاعات ثبت شد')
      }
    }

  }

  Find_MailMessage_Schedule(id: number) {
    for (let item of this.DataList_MailMessage_Schedule) {
      if (id == item.id) {
        return item.title
      }
    }
  }

  //#endregion


  //#region Dsc ملاحظات
  FormAdded_Dsc: Array<string> = []
  FormAdded_Dsc_Modir: Array<boolean> = []
  FormAdded_Dsc_Input: string = ''

  FormAdded_Dsc_Delete(id) {
    this.FormAdded_Dsc.splice(id, 1)
    this.FormAdded_Dsc_Modir.splice(id, 1)
    this.Alertify_Service.SuccessMessage(" حذف شد")
  }

  FormAdded_Dsc_Submit() {
    if (!this.FormAdded_Dsc_Input) {
      this.Alertify_Service.ErrorMessage("متن ملاحظه را وارد نمائید")
    }
    else {
      this.FormAdded_Dsc.push(this.FormAdded_Dsc_Input)
      this.FormAdded_Dsc_Modir.push(false)

      this.FormAdded_Dsc_Input = ''
      this.Alertify_Service.SuccessMessage('اطلاعات ثبت شد')
    }

  }

  //#endregion


  //#region Textletter
  DataList_Textletter: Array<Textletter_Interface> = []
  ReadData_Textletter() {

    this.get_Form_textletter_id().setValue("0")

    if (this.get_Form_subject_id().value == "0") {
      this.DataList_Textletter = []
    }
    else {
      this.Textletter_Service.GetRelativeRecord(Number(this.get_Form_subject_id().value)).subscribe(
        data => {

          this.DataList_Textletter = data

        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }

  //#endregion

  //#region  کارشناس کالیبراسیون

  ShowDelete_Schedule: boolean = false

  Set_ShowDelete_Schedule() {
    this.ShowDelete_Schedule = !this.ShowDelete_Schedule
  }


  ScheduleForm: FormGroup
  Schedule_DataList: Array<LetterRequestCustomer_Schedule_Interface> = []
  get_ScheduleForm_persianDate() {
    return this.ScheduleForm.get('persianDate') as FormControl;
  }

  get_ScheduleForm_startHour() {
    return this.ScheduleForm.get('startHour') as FormControl;
  }

  get_ScheduleForm_endHour() {
    return this.ScheduleForm.get('endHour') as FormControl;
  }

  get_ScheduleForm_Dsc() {
    return this.ScheduleForm.get('dsc') as FormControl;
  }

  get_ScheduleForm_Comment() {
    return this.ScheduleForm.get('comment') as FormControl;
  }

  ScheduleForm_Submit() {
    var Checker: boolean = false

    var checker_Persian: string = ''
    for (let detail of this.Schedule_DataList) {
      if (detail.persianDate == this.get_ScheduleForm_persianDate().value && detail.del == false) {
        //Checker = true
        break
      }
    }





    if (Checker) {
      this.Alertify_Service.ErrorMessage("تاریخ نظر در لیست ثبت شده است")
    }
    else {
      var temp: LetterRequestCustomer_Schedule_Interface = Empty_LetterRequestCustomer_Schedule_Interface()
      temp.persianDate = this.get_ScheduleForm_persianDate().value
      temp.dsc = this.get_ScheduleForm_Dsc().value
      temp.startDate = Number(this.get_ScheduleForm_startHour().value)
      temp.endDate = Number(this.get_ScheduleForm_endHour().value)
      temp.comment = Number(this.get_ScheduleForm_Comment().value)
      temp.del = false
      temp.expert = []
      this.Schedule_DataList.push(temp)

      this.Alertify_Service.SuccessMessage('اطلاعات ثبت شد')
    }
  }

  ScheduleForm_Delete(id) {
    if (this.Schedule_DataList[id].id == 0) {
      this.Schedule_DataList[id].del = true
      this.Alertify_Service.SuccessMessage(" حذف شد")
    }
    else {
      this.Alertify_Service.SuccessMessage("برای این ماموریت، لغو ماموریت باید صورت گیرد")
    }

  }

  modalRef_ExpertCalibration: any;
  Procssing_ExpertCalibration: boolean = false
  Proccessing_Schedule: LetterRequestCustomer_Schedule_Interface = Empty_LetterRequestCustomer_Schedule_Interface()

  openModal_ExpertCalibration(template: TemplateRef<any>, item: LetterRequestCustomer_Schedule_Interface) {
    this.modalRef_ExpertCalibration = this.modalService.show(template);
    this.Proccessing_Schedule = item
  }

  ExpertCalibrationpage: number = 0;
  Filter_Familly: string = ''
  Filter_Area: string = ''

  Change_Filter() {
    this.ExpertCalibrationpage = 0
  }

  ReadData_ExpertCalibration() {
    this.Procssing_ExpertCalibration = true

    this.ExpertCalibration_Service.GetActiveList(false, true, true).subscribe(
      data => {
        this.DataList_ExpertCalibration = data
        this.Procssing_ExpertCalibration = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  DataList_ExpertCalibration: Array<ExpertCalibration_Interface> = []

  Set_Selected_ExpertCalibration_Record(item: ExpertCalibration_Interface) {


    var Chekcer: boolean = false
    for (let detail of this.Proccessing_Schedule.expert) {
      if (detail.id == item.id && detail.del == false) {
        Chekcer = true
        break
      }
    }

    if (Chekcer) {
      this.Alertify_Service.ErrorMessage("کارشناس مورد نظر در لیست ثبت شده است")
    }
    else {

      item.del = false
      item.id_temp = 0

      this.Proccessing_Schedule.expert.push(item)
      //this.modalRef_ExpertCalibration.hide()
    }

  }

  ExpertCalibration_Delete(id, item: LetterRequestCustomer_Schedule_Interface) {
    item.expert[id].del = true
    this.Alertify_Service.SuccessMessage(" حذف شد")
  }

  ExpertCalibration_Visible(item: ExpertCalibration_Interface) {

    this.LetterRequestCustomer_Service.SetLetterRequestCustomerExpertsVisible(item.id_temp).subscribe(
      data => {
        item.visible = !item.visible
        this.Alertify_Service.SuccessMessage("تغییر اعمال شد")
      }
    )

  }

  DeviceBehfa_Delete(id, item: LetterRequestCustomer_Schedule_Interface) {
    item.deviceBehfa[id].del = true
    this.Alertify_Service.SuccessMessage(" حذف شد")
  }


  Change_Seleted_ExpertCalibration_Record(Record: LetterRequestCustomer_Schedule_Interface, indexer: number) {
    for (let item of Record.expert) {
      if (item.del == false) {
        item.seleted = false
      }
    }
    Record.expert[indexer].seleted = true
  }

  //#endregion

  //#region Device
  DeviceFormList: Array<LetterRequestCustomer_Device_Interface> = []
  DeviceForm: FormGroup;
  DeviceFormListPriceTotal: number = 0
  DeviceFormListPriceTotalTotal: number = 0
  DeviceFormListKhadamatTotal: number = 0
  DeviceFormListTakhfifTotal: number = 0
  DeviceFormListarsh_afzoodehTotal: number = 0

  get_DeviceForm_id() {
    return this.DeviceForm.get('id') as FormControl;
  }

  get_DeviceForm_device_id() {
    return this.DeviceForm.get('device_id') as FormControl;
  }

  get_DeviceForm_location() {
    return this.DeviceForm.get('location') as FormControl;
  }

  get_DeviceForm_incRailModir() {
    return this.DeviceForm.get('incRailModir') as FormControl;
  }

  get_DeviceForm_tedad() {
    return this.DeviceForm.get('tedad') as FormControl;
  }

  get_DeviceForm_Expiration() {
    return this.DeviceForm.get('Expiration') as FormControl;
  }

  get_DeviceForm_DscUser() {
    return this.DeviceForm.get('dscUser') as FormControl;
  }

  DeviceForm_Submit() {



    if (this.get_DeviceForm_location().value == "0") {
      this.Alertify_Service.ErrorMessage("محل کالیبراسیون را انتخاب کنید")
    }
    else if (this.Edit_Device_Form_Index == -1 && this.selected_Tariff_Record.id == 0) {
      this.Alertify_Service.ErrorMessage("ملاحظه را انتخاب کنید")
    }
    else if (this.get_DeviceForm_device_id().value == "0" && this.Edit_Device_Form_Index == -1) {
      this.Alertify_Service.ErrorMessage("عنوان فارسی را انتخاب کنید")
    }
    else if (this.get_DeviceForm_Expiration().value == "0") {
      this.Alertify_Service.ErrorMessage("مدت انقضاء را انتخاب نمائید")
    }
    else if (this.Edit_Device_Form_Index == -1) {
      var temp: LetterRequestCustomer_Device_Interface = Empty_LetterRequestCustomer_Device_Interface()
      temp.device_id = Number(this.get_DeviceForm_device_id().value)
      temp.device_name = this.Find_DataList_Devicepersian_Title(this.get_DeviceForm_device_id().value)

      if (this.get_DeviceForm_location().value == "1") {
        temp.location_id = 1
        temp.location_name = 'محل مشتری'
      }
      else {
        temp.location_id = 0
        temp.location_name = 'آزمایشگاه بهینه'
      }

      temp.tedad = Number(this.get_DeviceForm_tedad().value)
      temp.expiration = Number(this.get_DeviceForm_Expiration().value)
      temp.expiration_title = this.Find_Expiration_Title(Number(this.get_DeviceForm_Expiration().value))
      temp.dscUser = this.get_DeviceForm_DscUser().value

      //var tempTariff = this.Find_DataList_Tariff_Title(Number(this.get_DeviceForm_price().value))

      temp.price_dsc = this.selected_Tariff_Record.dsc
      temp.price = Number(this.selected_Tariff_Record.tariff)
      temp.price_id = Number(this.selected_Tariff_Record.id)

      temp.incRailModir = Number(this.get_DeviceForm_incRailModir().value)

      this.DeviceFormList.push(temp)
      this.Calc_DeviceFormListPriceTotal()
      this.Edit_Device_Form_Index = -1
    }
    else if (this.Edit_Device_Form_Index > -1) {
      var temp: LetterRequestCustomer_Device_Interface = this.DeviceFormList[this.Edit_Device_Form_Index]

      if (this.get_DeviceForm_location().value == "1") {
        temp.location_id = 1
        temp.location_name = 'محل مشتری'
      }
      else {
        temp.location_id = 0
        temp.location_name = 'آزمایشگاه بهینه'
      }

      console.log(this.Edit_Device_Form_Index);


      temp.tedad = Number(this.get_DeviceForm_tedad().value)
      temp.expiration = Number(this.get_DeviceForm_Expiration().value)
      temp.expiration_title = this.Find_Expiration_Title(Number(this.get_DeviceForm_Expiration().value))
      temp.dscUser = this.get_DeviceForm_DscUser().value
      //var tempTariff = this.Find_DataList_Tariff_Title(Number(this.get_DeviceForm_price().value))

      //temp.price_dsc = this.selected_Tariff_Record.dsc
      //temp.price = Number(this.selected_Tariff_Record.tariff)
      //temp.price_id = Number(this.selected_Tariff_Record.id)

      temp.incRailModir = Number(this.get_DeviceForm_incRailModir().value)

      this.Calc_DeviceFormListPriceTotal()
      this.Cancel_DeviceFormList()
    }

  }

  Find_DataList_Devicepersian_Title(id) {
    for (let item of this.DataList_Devicepersian) {
      if (item.id == id) {
        return item.dsc
      }
    }
  }

  Find_DataList_Tariff_Title(id): Tariff_Interface {
    for (let item of this.DataList_Tariff) {
      if (item.id == id) {
        return item
      }
    }
  }

  DeleteDeviceFormList_Index: number = -1;
  DeleteDeviceFormList_Record: LetterRequestCustomer_Device_Interface = Empty_LetterRequestCustomer_Device_Interface();

  modalRef_DeleteDeviceFormList: any
  DeleteDeviceFormList_Modal(template: TemplateRef<any>, id: number) {
    this.DeleteDeviceFormList_Index = id
    this.DeleteDeviceFormList_Record = this.DeviceFormList[this.DeleteDeviceFormList_Index]
    this.modalRef_DeleteDeviceFormList = this.modalService.show(template);
  }

  DeleteDeviceFormList() {

    if (this.DeleteDeviceFormList_Record.id == 0) {
      this.DeviceFormList.splice(this.DeleteDeviceFormList_Index, 1)
      this.Alertify_Service.SuccessMessage(" حذف شد")
      this.Calc_DeviceFormListPriceTotal()
      this.modalRef_DeleteDeviceFormList.hide()
    }
    else {
      this.InProccessing = true
      this.LetterRequestCustomer_Service.DeleteDevice(this.DeleteDeviceFormList_Record.id).subscribe(
        data => {
          this.InProccessing = false
          this.DeviceFormList.splice(this.DeleteDeviceFormList_Index, 1)
          this.Alertify_Service.SuccessMessage(" حذف شد")
          this.Calc_DeviceFormListPriceTotal()
          this.modalRef_DeleteDeviceFormList.hide()
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }

  Edit_Device_Form_Index: number = -1
  EditDeviceFormList(id) {

    var temp = this.DeviceFormList[id]
    this.ReadData_Tariff_By_Tariff_Id(temp.price_id)

    if (temp.location_id == 0) {
      this.get_DeviceForm_location().setValue("2")
    }
    else {
      this.get_DeviceForm_location().setValue("1")
    }


    this.get_DeviceForm_tedad().setValue(temp.tedad)
    this.get_DeviceForm_Expiration().setValue(temp.expiration)
    this.get_DeviceForm_incRailModir().setValue(temp.incRailModir)
    this.get_DeviceForm_DscUser().setValue(temp.dscUser)

    this.selected_Tariff_Record = this.Find_DataList_Tariff_Title(temp.price_id)

    this.Edit_Device_Form_Index = id
  }

  set_Selected_Tariff(item: Tariff_Interface) {
    this.selected_Tariff_Record = item
    this.get_DeviceForm_incRailModir().setValue(item.modirPrice)
  }

  Cancel_DeviceFormList() {
    this.Edit_Device_Form_Index = -1


    this.get_DeviceForm_location().setValue("1")
    this.get_DeviceForm_tedad().setValue("0")
    this.get_DeviceForm_Expiration().setValue("0")
    this.get_DeviceForm_incRailModir().setValue("0")
    this.get_DeviceForm_device_id().setValue("0")
    this.selected_Tariff_Record = Empty_Tariff_Interface()
    this.DataList_Tariff = []
    this.DataList_Devicepersian = []
    this.Data_Seleted_Device_Record = Empty_Device_Interface()
  }

  Device_upgrade(index: number) {
    var temp = this.DeviceFormList[index]
    this.DeviceFormList[index] = this.DeviceFormList[index - 1]
    this.DeviceFormList[index - 1] = temp
  }

  Device_downgrade(index: number) {
    var temp = this.DeviceFormList[index]
    this.DeviceFormList[index] = this.DeviceFormList[index + 1]
    this.DeviceFormList[index + 1] = temp
  }

  Device_downgrade_Last(index: number) {
    for (var i = index + 1; i < this.DeviceFormList.length; i++) {
      var temp = this.DeviceFormList[i - 1]
      this.DeviceFormList[i - 1] = this.DeviceFormList[i]
      this.DeviceFormList[i] = temp
    }
  }

  Device_upgrade_First(index: number) {

    var i: number = index - 1
    while (i >= 0) {
      var temp = this.DeviceFormList[i + 1]
      this.DeviceFormList[i + 1] = this.DeviceFormList[i]
      this.DeviceFormList[i] = temp
      i = i - 1
    }

  }

  DeviceCount_InLocation: number = 0
  DeviceCount_OutLocation: number = 0

  DevicePrice_InLocation: number = 0
  DevicePrice_OutLocation: number = 0

  Calc_DeviceFormListPriceTotal() {
    this.DeviceFormListPriceTotal = 0
    this.DeviceFormListPriceTotalTotal = 0
    this.DeviceFormListKhadamatTotal = 0
    this.DeviceFormListarsh_afzoodehTotal = 0
    this.DeviceFormListTakhfifTotal = 0

    this.DeviceCount_InLocation = 0
    this.DeviceCount_OutLocation = 0

    this.DevicePrice_InLocation = 0
    this.DevicePrice_OutLocation = 0

    for (let item of this.DeviceFormList) {
      var tempPrice = item.price + item.incRailModir

      if (item.location_id == 1) {
        this.DeviceCount_InLocation = this.DeviceCount_InLocation + item.tedad
        this.DevicePrice_InLocation = this.DevicePrice_InLocation + ((item.price + item.incRailModir) * item.tedad)
      }
      else {
        this.DeviceCount_OutLocation = this.DeviceCount_OutLocation + item.tedad
        this.DevicePrice_OutLocation = this.DevicePrice_OutLocation + ((item.price + item.incRailModir) * item.tedad)
      }


      this.DeviceFormListPriceTotal = this.DeviceFormListPriceTotal + (item.tedad * tempPrice)
    }

    this.DeviceFormListPriceTotalTotal = this.DeviceFormListPriceTotal

    if (this.get_Form_khadamat().value && Number(this.get_Form_khadamat().value >= 0)) {
      this.DeviceFormListKhadamatTotal = Number(this.get_Form_khadamat().value)
      this.DeviceFormListPriceTotalTotal = this.DeviceFormListPriceTotalTotal + this.DeviceFormListKhadamatTotal
    }

    if (this.get_Form_takhfif().value && (Number(this.get_Form_takhfif().value >= 0 && this.get_Form_takhfif().value <= 100))) {
      this.DeviceFormListTakhfifTotal = this.DeviceFormListPriceTotalTotal * (Number(this.get_Form_takhfif().value) / 100)
      this.DeviceFormListPriceTotalTotal = this.DeviceFormListPriceTotalTotal - this.DeviceFormListTakhfifTotal
    }

    if (this.get_Form_arsh_afzoodeh().value && (Number(this.get_Form_arsh_afzoodeh().value >= 0 && this.get_Form_arsh_afzoodeh().value <= 100))) {
      this.DeviceFormListarsh_afzoodehTotal = this.DeviceFormListPriceTotalTotal * (Number(this.get_Form_arsh_afzoodeh().value) / 100)
      this.DeviceFormListPriceTotalTotal = this.DeviceFormListPriceTotalTotal + this.DeviceFormListarsh_afzoodehTotal
    }



  }

  Calc_IncreaseModir(IsPrice:boolean,item:LetterRequestCustomer_Device_Interface)
  {
    if(IsPrice)
    {
      item.incPercentModir = (item.incRailModir*100)/item.price
    }
    else{
      item.incRailModir = (item.incPercentModir*item.price)/100
    }
    this.Calc_DeviceFormListPriceTotal()
  }

  //#endregion

  //#region  دستگاه

  modalRef_Device: any;

  ProcssingDevice: boolean = false

  Search_Name_Device_Table: string = ''
  Search_Code_Device_Table: string = ''

  openModal_Device(template: TemplateRef<any>) {
    this.modalRef_Device = this.modalService.show(template);
  }

  DataList_Device: Array<Device_Interface> = []
  Data_Seleted_Device_Record: Device_Interface = Empty_Device_Interface()

  ReadData_Device_KeySearch_Timer: any
  ReadData_Device_KeySearch() {

    if (this.ReadData_Device_KeySearch_Timer) {
      clearTimeout(this.ReadData_Device_KeySearch_Timer);
      this.ReadData_Device_KeySearch_Timer = null;
    }

    this.ReadData_Device_KeySearch_Timer = setTimeout(function () {
      this.ReadData_Device()
    }.bind(this), 1000);

  }

  ReadData_Device() {


    if (!this.Search_Name_Device_Table) {
      this.DataList_Device = []
    }
    else {
      this.ProcssingDevice = true
      this.Device_Service.GetSearchCalibration(this.Search_Name_Device_Table, this.Search_Code_Device_Table).subscribe(
        data => {
          this.DataList_Device = data
          this.ProcssingDevice = false
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }

  Set_Selected_Device_Record(item) {
    this.Data_Seleted_Device_Record = item
    this.modalRef_Device.hide()
    this.ReadData_Devicepersian()
  }

  //#endregion

  //#region Devicepersian

  DataList_Devicepersian: Array<Devicepersian_Interface> = []

  ReadData_Devicepersian() {
    this.Devicepersian_Service.GetDevicePersian(this.Data_Seleted_Device_Record.id).subscribe(
      data => {
        /*
        var temp:Devicepersian_Interface=Empty_Devicepersian_Interface()
        temp.dsc=this.Data_Seleted_Device_Record.title
        temp.id = -1
        data.push(temp)
        */

        this.DataList_Devicepersian = data
        this.get_DeviceForm_device_id().setValue("0")
        this.ReadData_Tariff()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  //#endregion

  //#region Tariff

  selected_Tariff_Record: Tariff_Interface = Empty_Tariff_Interface()
  DataList_Tariff: Array<Tariff_Interface> = []
  ReadData_Tariff() {
    this.Tariff_Service.GetDeviceTariff(this.Data_Seleted_Device_Record.id, this.Data_Seleted_Customer.id).subscribe(
      data => {
        this.DataList_Tariff = data
        this.selected_Tariff_Record = Empty_Tariff_Interface()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  ReadData_Tariff_By_Tariff_Id(id: number) {
    this.Tariff_Service.GetDeviceTariff_By_Tariff_Id(id).subscribe(
      data => {
        this.DataList_Tariff = data

      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


  //#endregion


  //#region LetterRequestCustomer

  Selected_DataList_LetterRequestCustomer_Record: LetterRequestCustomer_List_Interface = Empty_LetterRequestCustomer_List_Interface()

  modalRef_LetterRequestCustomer: any;
  modalRef_LetterRequestCustomerCopy: any;

  Procssing_LetterRequestCustomer: boolean = false
  Procssing_LetterRequestCustomerCopy: boolean = false

  Search_code_LetterRequestCustomer: String = ''
  Search_code_LetterRequestCustomerCopy: String = ''
  Search_persianDate_LetterRequestCustomer: String = ''
  Search_customer_LetterRequestCustomer: String = ''

  openModal_LetterRequestCustomer(template: TemplateRef<any>) {
    this.modalRef_LetterRequestCustomer = this.modalService.show(template);
    this.Search_code_LetterRequestCustomerCopy = ''
  }

  openModal_LetterRequestCustomerCopy(template: TemplateRef<any>) {
    this.modalRef_LetterRequestCustomerCopy = this.modalService.show(template);
  }


  Selected_DataList_LetterRequestCustomer: LetterRequestCustomer_List_Interface = Empty_LetterRequestCustomer_List_Interface()
  DataList_LetterRequestCustomer: Array<LetterRequestCustomer_List_Interface> = []

  ReadData_LetterRequestCustomer() {
    this.Procssing_LetterRequestCustomer = true

    this.LetterRequestCustomer_Service.GetLetterRequestCustomerPeyvaset(0,
      Number(this.Search_code_LetterRequestCustomer),
      this.Search_customer_LetterRequestCustomer).subscribe(
        data => {
          this.DataList_LetterRequestCustomer = data
          this.Procssing_LetterRequestCustomer = false
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )

  }


  Set_Selected_LetterRequestCustomer(item: LetterRequestCustomer_List_Interface) {
    this.Selected_DataList_LetterRequestCustomer_Record = item

    this.Selected_DataList_LetterRequestCustomer = item


    this.get_Form_giver_name().setValue(item.giver_name)
    this.get_Form_giver_semat().setValue(item.giver_semat)


    this.get_Form_peyvast().setValue("1")
    this.get_Form_bazgashtBeNamehShomareh().setValue(item.bazgashtBeNamehShomareh)
    this.get_Form_bazgashtBeNamehTarikh().setValue(item.bazgashtBeNamehTarikh)

    if (item.sex == true)
      this.get_Form_sex().setValue('1')
    else
      this.get_Form_sex().setValue('0')

    this.Data_Seleted_Customer.id = Number(this.Selected_DataList_LetterRequestCustomer.customerId)
    this.Data_Seleted_Customer.name = this.Selected_DataList_LetterRequestCustomer.customer + ''
    this.modalRef_LetterRequestCustomer.hide()

    if (item.letterType == 'درخواست کالیبراسیون') {
      this.Copy_LetterRequestCustomer_Device(item.id)
    }

  }

  Copy_LetterRequestCustomer() {
    this.Procssing_LetterRequestCustomerCopy = true
    this.LetterRequestCustomer_Service.GetCopy(Number(this.Search_code_LetterRequestCustomerCopy)).subscribe(
      data => {
        this.Procssing_LetterRequestCustomerCopy = false
        if (data['canCopy'] == 0) {
          this.Alertify_Service.SuccessMessage("شماره نامه وارد شده معتبر نمی باشد")
        }
        else {

          this.modalRef_LetterRequestCustomerCopy.hide()
          this.Alertify_Service.SuccessMessage("کپی انجام شد")

          this.Data_Seleted_Customer = data['cusomter']
          this.Data_Seleted_Address = data['address']
          this.FormAdded_MailMessage = data['mail']


          for (let item of data['dsc']) {
            this.FormAdded_Dsc.push(item['dsc'])
            this.FormAdded_Dsc_Modir.push(item['modirEdit'])
          }

          this.Letter_Form_Code = data['lettercode']
          this.Letter_Form_Code_Code = data['code']

          this.DeviceFormList = data['device']
          var temp: Letter_Interface = data['main']


          this.Data_Seleted_ReciveCustomer.id = Number(temp.reciver_Customer_id)
          this.Data_Seleted_ReciveCustomer.name = data['reciver_Customer']
          this.Data_Seleted_ReciveCustomer_Dsc = temp.reciver_Customer_Dsc + ''


          if (this.Selected_DataList_LetterRequestCustomer_Record.id > 0) {
            this.get_Form_peyvast().setValue("1")

          }

          this.get_Form_bazgashtBeNamehTarikh().setValue(data['bazgashtBeNamehTarikh'])

          if (data['main']['peyvast'] == true)
            this.get_Form_peyvast().setValue('1')
          else
            this.get_Form_peyvast().setValue('0')

          if (data['main']['sex'] == true)
            this.get_Form_sex().setValue('1')
          else
            this.get_Form_sex().setValue('0')

          this.get_Form_giver_name().setValue(temp.giver_name)
          this.get_Form_giver_semat().setValue(temp.giver_semat)
          this.get_Form_subject_id().setValue(temp.subject_id)

          this.get_Form_bazgashtBeNamehShomareh().setValue(temp.bazgashtBeNamehShomareh)
          this.get_Form_takhfif().setValue(temp.takhfif)


          this.get_Form_arsh_afzoodeh().setValue(temp.arsh_afzoodeh)
          this.get_Form_pishPardakht().setValue(temp.pishPardakht)
          this.get_Form_khadamat().setValue(temp.khadamat)
          this.ReadData_Textletter()
          this.ReadData_SubjectLetter()
          this.Calc_DeviceFormListPriceTotal()
          this.get_Form_textletter_id().setValue(temp.textletter_id)
          this.pishPardakht_Change()
          this.khadamat_Change()

        }


      }, error => {
        this.Alertify_Service.SuccessMessage("شماره نامه وارد شده معتبر نمی باشد")
      }
    )
  }

  Copy_LetterRequestCustomer_Device(id: number) {
    this.Procssing_LetterRequestCustomerCopy = true
    this.LetterRequestCustomer_Service.GetSingle(id).subscribe(
      data => {
        this.Procssing_LetterRequestCustomerCopy = false
        if (data['canCopy'] == 0) {
          this.Alertify_Service.SuccessMessage("شماره نامه معتبر نمی باشد")
        }
        else {

          this.DeviceFormList = data['device']
        }


      }, error => {
        this.Alertify_Service.SuccessMessage("شماره نامه معتبر نمی باشد")
      }
    )
  }


  //#endregion



  //#region Letter Order

  Data_List_Order: Array<LetterRequestCustomer_Order_Interface>
  Read_Order_Operation() {
    this.Data_List_Order = []
    this.LetterRequestCustomer_Service.GetOperation(Number(this.Letter_Form_Id), Number(this.Letter_Draft_Form_Id), false, false, false).subscribe(
      data => {
        this.Read_Expiration()
        this.Data_List_Order = data['result']
        this.canEditMainForm = data['canEditMainForm']
        this.canDeleteHistoryRecord = data['canDeleteHistoryRecord']
        this.canEditPlannigForm = data['canEditPlaningForm']
        this.canCheckingPlaningForm = data['canCheckingPlaningForm']
        this.canDownloadPDF = data['canDownloadPDF']
        this.canDownloadPDFPlaning = data['canDownloadPDFPlaning']
        this.canFillReviewForm = data['canFillReviewForm']
        this.hiddenDetailAndPrice = data['hiddenDetailAndPrice']
        this.parentRefer = data['parentRefer']
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


  Selected_Order_Operation: LetterRequestCustomer_Order_Interface = Empty_LetterRequestCustomer_Order_Interface()
  SelectedLetterRole: string = '0'
  LetterHistoryDsc: string = ''
  modalRef_Order: any;
  Data_list_LetterRole: Array<General_Interface> = []
  OpenOrderDialog(template: TemplateRef<any>, item: LetterRequestCustomer_Order_Interface) {
    this.Data_list_LetterRole = []
    this.SelectedLetterRole = '0'
    this.LetterHistoryDsc = ''
    this.Selected_Order_Operation = item
    this.InProccessing = true
    this.LetterRequestCustomer_Service.GetUserrole(item.id, item.role_id).subscribe(
      data => {
        this.InProccessing = false
        this.Data_list_LetterRole = data
        this.modalRef_Order = this.modalService.show(template);
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  //#endregion


  //#region MonshiResponse

  modalRef_Request90: any;
  selectedItem_Schedule_Record: LetterRequestCustomer_Schedule_Interface = Empty_LetterRequestCustomer_Schedule_Interface()
  statusFunction: number = 0
  openModal90(template: TemplateRef<any>, statu: number, selectedItem: LetterRequestCustomer_Schedule_Interface) {
    this.modalRef_Request90 = this.modalService.show(template);
    this.statusFunction = statu;
    this.selectedItem_Schedule_Record = selectedItem;
  }

  ChangeStatus_Request90() {
    this.InProccessing = true
    this.modalRef_Request90.hide()
    this.LetterRequestCustomer_Service.ChangeStatus90(this.selectedItem_Schedule_Record.id, this.statusFunction, "").subscribe(
      data => {
        this.selectedItem_Schedule_Record.status = (this.statusFunction == 1)
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        this.InProccessing = false
      }
    )
  }

  //#endregion

  //#region مدت انقضاء

  Data_List_Expiration: Array<FeildActivity_Interface> = []
  Read_Expiration() {
    this.Expiration_Service.GetActive().subscribe(
      data => {

        this.get_DeviceForm_Expiration().setValue("0")
        for (let item of data) {
          if (item.defaultt == true) {
            this.get_DeviceForm_Expiration().setValue(item.id)
            break;
          }
        }

        this.Data_List_Expiration = data

        this.Read_Customer_Karshnash()

      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }



  Find_Expiration_Title(id) {
    for (let item of this.Data_List_Expiration) {
      if (item.id == id) {
        return item.title
      }
    }
    return ''
  }

  //#endregion



  //#region History

  Show_History_View: number = 0
  DataList_History: Array<LetterRequestCustomer_History_Interface> = []
  ReadHistory_Letter() {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.GetHistory(Number(this.Letter_Form_Id)).subscribe(
      data => {
        this.InProccessing = false
        this.Show_History_View = 1
        this.DataList_History = data
        this.ReadPeyvast_Letter()

      }
    )
  }

  DeleteLetterHistoryRecord() {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.DeleteLetterHistoryRecord(Number(this.Letter_Form_Id)).subscribe(
      data => {
        this.InProccessing = false
        if (data['id'] == 1) {
          this.ReadHistory_Letter()
        }
        else {
          this.Alertify_Service.ErrorMessage("امکان حذف وجود ندارد")
        }

      }
    )
  }

  DataList_Peyvast: Array<LetterRequestCustomer_List_Interface> = []
  canOpenPeyvast: boolean=false
  ReadPeyvast_Letter() {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.GetPeyvast1(Number(this.Letter_Form_Id)).subscribe(
      data => {
        this.InProccessing = false
        this.DataList_Peyvast = data['result']
        this.canOpenPeyvast = data['canOpen']       
      }
    )
  }

  Close_Show_History() {
    this.Show_History_View = 0
  }

  //#endregion


  //#region Note Letter

  modalRef_Note: any;
  Note_Dsc: string = ''
  OpenNoteDialog(template: TemplateRef<any>) {
    this.modalRef_Note = this.modalService.show(template);
    this.Note_Dsc = ''
  }

  SubmitNote() {
    if (!this.Note_Dsc) {
      this.Alertify_Service.ErrorMessage("شرح را وارد نمائید")
    }
    else {
      this.InProccessing = true

      this.Customer_Service.AddComment(this.Note_Dsc, this.Data_Seleted_Customer.id).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("نظر ثبت شد")
          this.InProccessing = false
          this.Note_Dsc = ''
          this.modalRef_Note.hide()
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.
        }
      )
    }
  }

  //#endregion



  //#region  Device Behfa

  DataList_DeviceBehfa_Schedule: Array<string> = []
  modalRef_DeviceBehfa: any;
  modalRef_DeviceBehfaSchedule: any;
  Temp_DeviceBehfa_Record: DeviceBehfa_Interface = Empty_DeviceBehfa_Interface()

  openModal_DeviceBehfa(template: TemplateRef<any>, item: LetterRequestCustomer_Schedule_Interface) {
    this.modalRef_DeviceBehfa = this.modalService.show(template);
    this.Proccessing_Schedule = item
  }

  Set_Selected_DeviceBehfa_Record(item: DeviceBehfa_Interface, template: TemplateRef<any>) {
    var Chekcer: boolean = false
    for (let detail of this.Proccessing_Schedule.deviceBehfa) {
      if (detail.id == item.id && detail.del == false) {
        Chekcer = true
        break
      }
    }

    if (Chekcer) {
      this.Alertify_Service.ErrorMessage("تجهیز بهفا مورد نظر در لیست ثبت شده است")
    }
    else {
      item.del = false
      item.id_temp = 0

      if (item.deviceBehfa_Schedule.length > 0) {
        this.modalRef_DeviceBehfa.hide()
        this.modalRef_DeviceBehfaSchedule = this.modalService.show(template);
        this.DataList_DeviceBehfa_Schedule = item.deviceBehfa_Schedule
        this.Temp_DeviceBehfa_Record = item
      }
      else {
        this.DataList_DeviceBehfa_Schedule = []
        this.Proccessing_Schedule.deviceBehfa.push(item)
      }
    }
  }

  Set_Selected_DeviceBehfa_Record_Co(template: TemplateRef<any>, Status: number) {
    this.modalRef_DeviceBehfaSchedule.hide()

    this.modalRef_DeviceBehfa = this.modalService.show(template);
    this.DataList_DeviceBehfa_Schedule = []
    if (Status == 1) {
      this.Proccessing_Schedule.deviceBehfa.push(this.Temp_DeviceBehfa_Record)
    }
  }


  //#endregion


  Letter_Form_Code: String = ''
  Letter_Form_Code_Code: String = ''
  modalRef_Code: any;

  InProccessing: boolean = false
  SubmitAddNewLetter(template: TemplateRef<any>, templateTarrifFloor: TemplateRef<any>, GiverUser: number, Order: LetterRequestCustomer_Order_Interface, LetterTarrifFloor: number = 0) {

    var indexerSchdule: number = 0
    var chegerSchdule: boolean = false
    for (let item of this.Schedule_DataList) {
      if (item.del == false) {
        var Counter: number = 0
        for (let itemExp of item.expert) {
          if (itemExp.del == false) {
            Counter++
          }
        }

        if (Counter == 0) {
          chegerSchdule = true
          break;
        }

      }

      indexerSchdule++
    }


    var indexerSchdule_Super: number = 0
    var chegerSchdule_Super: boolean = false
    for (let item of this.Schedule_DataList) {
      if (item.del == false) {
        var Counter: number = 0
        for (let itemExp of item.expert) {
          if (itemExp.seleted == true && itemExp.del == false) {
            Counter++
          }
        }

        if (Counter == 0) {
          chegerSchdule_Super = true
          break;
        }
      }


      indexerSchdule_Super++
    }

    var Check_Has_OutLocation_Device: boolean = false
    for (let item of this.DeviceFormList) {
      if (item.location_id == 0) {
        Check_Has_OutLocation_Device = true
        break;
      }
    }


    if (this.get_Form_subject_id().value == "0") {
      this.Alertify_Service.ErrorMessage("موضوع نامه را انتخاب نمائید")
    }

    else if (this.Data_Seleted_Address.id == 0 && Check_Has_OutLocation_Device) {
      this.Alertify_Service.ErrorMessage("آدرس محل استقرار تجهیزات مشتری را انتخاب نمائید")
    }

    else if (this.get_Form_textletter_id().value == "0") {
      this.Alertify_Service.ErrorMessage("متن نامه را انتخاب نمائید")
    }
    else if (this.DeviceFormList.length == 0) {
      this.Alertify_Service.ErrorMessage("حداقل یک مورد تجهیز وارد نمائید")
    }
    else if (this.canEditPlannigForm && this.Schedule_DataList.length == 0 && Order.id != 29) {
      this.Alertify_Service.ErrorMessage("حداقل یک مورد تاریخ وارد نمائید")
    }
    else if (this.canEditPlannigForm && chegerSchdule) {
      this.Alertify_Service.ErrorMessage(" ردیف " + (indexerSchdule + 1) + " برنامه ریزی فاقد کارشناس می باشد ")
    }
    else if (this.canEditPlannigForm && chegerSchdule_Super) {
      this.Alertify_Service.ErrorMessage(" ردیف " + (indexerSchdule_Super + 1) + " برنامه ریزی فاقد سرپرست می باشد ")
    }
    else {
      var temp: Letter_Interface = Empty_Letter_Interface()
      temp.id = Number(this.Letter_Form_Id)
      temp.giver_name = this.get_Form_giver_name().value
      temp.giver_semat = this.get_Form_giver_semat().value
      temp.subject_id = Number(this.get_Form_subject_id().value)
      temp.peyvast = (Number(this.get_Form_peyvast().value) == 1)
      temp.bazgashtBeNamehShomareh = this.get_Form_bazgashtBeNamehShomareh().value
      temp.takhfif = Number(this.get_Form_takhfif().value)
      temp.sex = (this.get_Form_sex().value == "1")
      temp.arsh_afzoodeh = Number(this.get_Form_arsh_afzoodeh().value)
      temp.pishPardakht = Number(this.get_Form_pishPardakht().value)
      temp.khadamat = Number(this.get_Form_khadamat().value)
      temp.textletter_id = Number(this.get_Form_textletter_id().value)

      temp.reciver_Customer_id = this.Data_Seleted_ReciveCustomer.id
      temp.reciver_Customer_Dsc = this.Data_Seleted_ReciveCustomer_Dsc


      this.InProccessing = true
      this.LetterRequestCustomer_Service.AddEditLetterRequestCustomer(
        temp,
        this.get_Form_bazgashtBeNamehTarikh().value,
        this.Data_Seleted_Customer,
        this.Data_Seleted_Address,
        this.DeviceFormList,
        this.Schedule_DataList,
        this.FormAdded_MailMessage,
        this.FormAdded_MailMessage_Schedule,
        this.FormAdded_Dsc,
        [],
        false,
        false,
        false,
        this.Selected_DataList_LetterRequestCustomer_Record.id,
        this.Letter_Draft_Form_Id != '0',
        GiverUser,
        Order.goSection,
        Order.id,
        this.LetterHistoryDsc,
        this.parentRefer,
        LetterTarrifFloor).subscribe(
          data => {
            this.InProccessing = false
            if (data.id == -1) {
              this.Alertify_Service.ErrorMessage(data.dsc + '')
              
            }
            else if (data.id == -2) {
              this.TarrifFloorDsc = data.dsc + ''
              this.modalRef_LetterTarrifFloor = this.modalService.show(templateTarrifFloor)

              this.SaveSendLetter_GiverUser = GiverUser
              this.SaveSendLetter_Order = Order
              this.SaveSendLetter_Template = template
              this.SaveSendLetter_templateTarrifFloor = templateTarrifFloor
            }
            else {
              this.Letter_Form_Code = data['giver_name']
              this.Letter_Form_Id = data['id']

              this.OnInitail_Form()
              this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

              if (Order.id == 8 || Order.id == 10 || Order.id == 6) {
                this.canShowSendSMS = true
                this.SendSMS_Order = Order.id
                this.modalRef_Code = this.modalService.show(template);
              }
              else {
                this.canShowSendSMS = false
                this.modalRef_Code = this.modalService.show(template);
              }

            }



            this.InProccessing = false
          }
        )
    }
  }

  SubmitActionLetter(GiverUser: number, Order: LetterRequestCustomer_Order_Interface) {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.SubmitActionLetter(
      this.Letter_Form_Id,
      GiverUser,
      Order.goSection,
      Order.id,
      this.LetterHistoryDsc,
      this.parentRefer).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          this.InProccessing = false
          this.Read_Order_Operation()
        }
      )
  }

  SubmitAddNewLetter_Co(template: TemplateRef<any>, templateTarrifFloor: TemplateRef<any>, item: LetterRequestCustomer_Order_Interface) {

    if (item.submit) {
      if (this.SelectedLetterRole == "0") {
        this.Alertify_Service.ErrorMessage("گیرنده را انتخاب کنید")
      }
      else {
        this.modalRef_Order.hide()
        this.SubmitAddNewLetter(template, templateTarrifFloor, Number(this.SelectedLetterRole), item)
      }
    }
    else if (item.hasRefer) {
      if (this.SelectedLetterRole == "0") {
        this.Alertify_Service.ErrorMessage("گیرنده را انتخاب کنید")
      }
      else {
        this.modalRef_Order.hide()
        this.SubmitActionLetter(Number(this.SelectedLetterRole), item)
      }
    }
    else {
      this.modalRef_Order.hide()
      this.SubmitActionLetter(0, item)
    }
  }


  //#region Save Send Letter
  TarrifFloorDsc: string = ''
  modalRef_LetterTarrifFloor: any

  SaveSendLetter_GiverUser: number
  SaveSendLetter_Order: LetterRequestCustomer_Order_Interface
  SaveSendLetter_Template: TemplateRef<any>
  SaveSendLetter_templateTarrifFloor: TemplateRef<any>
  LetterTarrifFloor() {
    this.modalRef_LetterTarrifFloor.hide()
    this.SubmitAddNewLetter(this.SaveSendLetter_Template, this.SaveSendLetter_templateTarrifFloor, this.SaveSendLetter_GiverUser, this.SaveSendLetter_Order, 1)
  }
  //#endregion

  //#region Karshnash Tel

  modalRef_Karshans: any;
  openModal_Karshans(template: TemplateRef<any>) {
    this.modalRef_Karshans = this.modalService.show(template);
  }


  //#endregion


  //#region SMS

  DataList_Karshnash: Array<KarshnasMasol_Interface> = []
  SendSMS_Order: number = 0
  SendSMS() {

    var Karshnash_Id: string = '-1'
    for (let item of this.DataList_Karshnash) {
      if (item.del) {
        Karshnash_Id = Karshnash_Id + "," + item.id
      }
    }


    this.modalRef_Code.hide()
    this.LetterRequestCustomer_Service.SendSmsLetter(Number(this.Letter_Form_Id), this.SendSMS_Order, Karshnash_Id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("پیامک ارسال شد")
      }
    )
  }

  Read_Customer_Karshnash() {
    if (this.Data_Seleted_Customer.id > 0) {
      this.InProccessing = true
      this.Customer_Service.GetSingle(this.Data_Seleted_Customer.id).subscribe(
        data => {
          this.InProccessing = false
          this.DataList_Karshnash = data['karshnasMasol']

          if (this.DataList_Karshnash.length == 0) {
            this.canShowSendSMS = false
          }
        }
      )
    }
  }

  Change_Selected_Of_Karshnash(item: KarshnasMasol_Interface) {
    item.del = !item.del
  }

  //#endregion


  //#region Activity
  Selected_LetterRequestCustomer_Schedule: LetterRequestCustomer_Schedule_Interface = Empty_LetterRequestCustomer_Schedule_Interface()
  Show_Activity_View(item: LetterRequestCustomer_Schedule_Interface) {
    this.Selected_LetterRequestCustomer_Schedule = item
    this.Show_History_View = 2
  }

  Show_Review_View() {
    this.Show_History_View = 3
  }

  //#endregion


  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, "BehfaDevice.xlsx");

  }

}
